import { type Component, markRaw, ref } from 'vue';
import { toast } from 'vue-sonner';
import AppNotification from '@/modules/common/components/AppNotification.vue';
import { NotificationType } from '@/modules/common/enums/notification-type.ts';
import { ErrorUtil } from '@/modules/common/utils/error.util.ts';
import type { I18TParams } from '@/i18n.ts';

export interface NotificationComponent {
  component: Component;
  props: Record<string, unknown>;
}

export type NotificationMessage = string | I18TParams | NotificationComponent;

function notify(type: NotificationType, message: NotificationMessage, detail?: string, fullDetail?: string) {
  setTimeout(() => {
    const id = ref();

    id.value = toast.custom(markRaw(AppNotification), {
      duration: Infinity,
      componentProps: {
        id,
        type,
        message,
        detail,
        fullDetail,
      },
    });
  });
}

function notifyError(message: NotificationMessage, error?: unknown) {
  const data = ErrorUtil.getCommonError(error);

  notify(NotificationType.Error, message, data?.error_message, data?.error_message_full);
}

export const notification = {
  info: (message: NotificationMessage) => notify(NotificationType.Info, message),
  success: (message: NotificationMessage) => notify(NotificationType.Success, message),
  warning: (message: NotificationMessage) => notify(NotificationType.Warning, message),
  error: notifyError,
};
